import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { useQuery } from "@tanstack/react-query";
import { useDeviceKey } from "./useDeviceKey";

export const fetchRecordingAgendaItems = async (deviceKey: string, recordingId: string | undefined) => {
  if (!recordingId) {
    return "";
  }

  const url = `${import.meta.env.VITE_SMART_DEBRIEF_API}/v0/recording/${recordingId}/Subject`;

  const initialToken = recoverTokenInfo();

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${initialToken}`,
      "X-iBabs-Device-Id": deviceKey,
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const recordingAgendaItems = await response.json();
  return recordingAgendaItems;
};

export function useRecordingAgendaItems(recordingId: string | undefined) {
  const deviceKey = useDeviceKey();

  return useQuery({
    queryKey: ["recordingAgendaItems", recordingId],
    queryFn: () => fetchRecordingAgendaItems(deviceKey, recordingId),
    // staleTime: 1000 * 5,
    enabled: !!recordingId,
  });
}
